import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export const getMarcas = async () => {
  const token = localStorage.getItem("token");
  const response = await axios.get(`${API_URL}/api/marcas`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

// Añadir marca
export const addMarca = async (marca) => {
  const token = localStorage.getItem("token");
  const response = await axios.post(`${API_URL}/api/marcas`, marca, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

// Obtener todas las marcas
export const getAllMarcas = async () => {
  const token = localStorage.getItem("token");
  const response = await axios.get(`${API_URL}/api/marcas/all`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

// Actualizar el estado de una marca
export const updateMarcaEstado = async (id, newEstado) => {
  const token = localStorage.getItem("token");
  const response = await axios.put(
    `${API_URL}/api/marcas/${id}/estado`,
    { ACTIVO: newEstado },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};
